import { FC } from 'react';
import { cn } from '@/shared/lib/utils';
import type { HeatmapCellFill } from '../lib/heatmapColors';

type Props = {
  fill: HeatmapCellFill;
};

/**
 * Заливка ячейки слоем под её содержимым: цвет темы с прозрачностью слоя. Прозрачность задана
 * слою, а не смешиванием цвета с прозрачным — так заливка видна и в браузерах без color-mix().
 * Родителю нужны `relative isolate`, чтобы слой лёг под текст, а не поверх.
 */
export const HeatmapCellFillLayer: FC<Props> = ({ fill }) => (
  <span
    aria-hidden
    className={cn('pointer-events-none absolute inset-0 -z-10', fill.colorClassName)}
    style={{ opacity: fill.opacity }}
  />
);
